import Main from '@/components/main'

export default [{
    path: '/project',
    meta: {
        hide: true,
        hideInMenu: true,
    },
    component: Main,
    children: [{
        path: 'detail/:id',
        name: 'projectDetail',
        meta: {
            title: '项目详情',
            parentName: "projManage",
            keepAlive: true,
        },
        component: () =>
            import('_v/proj-manage/detail/index')
    }]
}, {
    path: '/',
    redirect: {
        name: 'home'
    },
    meta: {
        hide: true,
        hideInMenu: true,
    },
    component: Main,
    children: [{
        path: 'home',
        meta: {
            title: "首页"
        },
        name: 'home',
        component: () =>
            import('_v/home/index')
    }]
}, ]